export const AREAS_CONSTS = {
    GET_AREAS: "GET_AREAS",
    GET_AREAS_INFO: "GET_AREAS_INFO",
    RESET_AREAS_INFO: "RESET_AREAS_INFO",
    GET_AREAS_INITIAL_INFO: "GET_AREAS_INITIAL_INFO",
    GET_AREA_SEARCH: "GET_AREA_SEARCH",
};
